// Copyright (c) 2017 Deere & Company

import Territories from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateUserTerritories = (state, action) =>
    Territories.update(state, {
        $set: action.territories
    });

export default (state = getDefaultState().territories, action) => {

    const actionTypes = {
        [actions.UPDATE_USER_TERRITORIES]: updateUserTerritories
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/user/shared/reducers/territories.js